<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
      <!-- <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{$t("withdraw.with_record")}}</span>
      </template> -->
    </van-nav-bar>
    <van-cell-group>
      <van-field v-model="withdraw_money" type="number" :placeholder="$t('q14')" />
      <van-field v-model="paypassword" type="password" :placeholder="$t('q15')" />
    </van-cell-group>
    <div class="p_c"><span>{{$t("my.balance")}}：</span>
      <span class="number">${{ this.userInfo.money }}</span></div>
    <div class="p_c">{{$t('q16')}}：{{ this.userInfo.name }}</div>
    <div class="hang_p_c">
      <input type="radio" checked>
      {{$t('q17')}} ：{{bankInfo.bankinfo}} {{bankInfo.fhnumber}}
    </div>
    <div v-if="withdrawDisabled" class="withdraw-disabled-tip">{{$t('withdraw.account_disabled')}}</div>
    
    <div class="sub-btn" :class="{'disabled':withdrawDisabled}" @click="doWithdraw()">
      {{$t('q18')}}
    </div>
    <!-- <div class="main">
      <div class="withdrawMoney">
        <span>{{$t("withdraw.with_money")}} ({{$t("reservation.unit")}})</span>
        <div class="money">
          <div class="moneyNumber">
           
            <van-field v-model="withdraw_money" type="number" />
          </div>
          <span class="all" @click="allMoeny()">{{$t("index.all")}}</span>
        </div>
        <div class="information">
          <div class="description">
            <van-popover v-model="showPopover" trigger="click">
              <div class="popover-body" style="padding: 10px;">
                <p>1.{{$t("withdraw.single_limit")}}{{$t("withdraw.low")}}{{this.withdrawRole.min}}{{$t("withdraw.heigh")}}{{this.withdrawRole.max}}{{$t("reservation.unit")}}</p>
                <p>2.{{$t("withdraw.with_num")}}{{this.withdrawRole.num}}{{$t("withdraw.number")}}</p>
                <p>3.{{$t("withdraw.with_tip")}}</p></div>
              <template #reference @click="withdrawInfo()">
                <van-icon name="info-o" />
                {{$t("withdraw.limit_desc")}}
              </template>
            </van-popover>
          </div>

          <div class="balance">
            <span>{{$t("my.balance")}}：</span>
            <span class="number">{{ this.userInfo.money }}{{$t("reservation.ge")}}</span>
          </div>
        </div>
      </div>
      <van-button class="withdraw_btn" type="default" @click="doWithdraw()"> {{$t("withdraw.immediately_withdraw")}}</van-button>

    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      money:"",
      paypassword:"",
      showPopover: false,
      withdraw_money:"",
      userInfo:{},
      withdrawRole:{},
      bankInfo:{},
      withdrawDisabled:false
    };
  },
  methods: {
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        console.log(res,"res--87")
        
        if(res.code === 200){
          this.bankInfo = res.data.info || {};
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    back(){
      return window.history.back();
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res=>{
        if(res.code === 200){
          console.log(res.data,"res.data---119")
          this.withdrawRole = res.data;
          this.withdrawDisabled = Number(res.data.withdraw_disabled) === 1;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw(){
      if(this.withdrawDisabled){
        this.$toast(this.$t('withdraw.account_disabled'));
        return false;
      }
      if(this.paypassword <= 0){
        
        this.$toast(this.$t('q24'));
        return false;
      }else
      if(this.withdraw_money <= 0){
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }else {
        this.$http({
          method: 'post',
          data:{money:this.withdraw_money,paypassword:this.paypassword},
          url: 'user_set_withdraw'
        }).then(res=>{
          if(res.code === 200){
            location.reload()
            this.$toast(res.msg);
            this.getUserInfo();
            this.getUserWithdrawRole();
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
        })
      }
    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      
      this.getUserInfo();
      this.getUserWithdrawRole();
     
    }
  },
  mounted(){
    this.getUserBankInfo();
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.p_c{
  color: #fff;
  padding:0 30px 20px;
  font-size: 28px;
}
.hang_p_c{
  padding:0 0px 20px;
  border-bottom: 1px solid #c5a081;
  margin: 0 20px;
  color: #c5a081;
  font-size: 28px;
}
.sub-btn{
  background: linear-gradient(#fde3ca, #e7b486);


  display: block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 2rem;
  margin: 40px;
  box-sizing: border-box;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}
.shuoming{
  background: #2e2e2e;
  color: #c1c1c1;
  padding: 40px 36px;
  .l_p{
    font-size: 26px;
    margin-top: 16px;
    &.q1{
      font-size: 30px;
    }
  }
}
/deep/ .van-field__label{
  color: #ccc;
}
.van-cell-group{
  background-color: transparent;
  padding: 30px 0;
  &:after{
    display: none;
  }
}
.van-cell{
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  &+.van-cell{
    margin-top: 30px;
  }
  
  /deep/ .van-field__control{
    color: #f3c7a2;
  }
  &:after{
    display: none;
  }
}

.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.container .main{
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}
.container .main .withdrawMoney{
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .money .moneyNumber{
  font-size: 50px;
  display: flex;
  flex-direction: row;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money .all{
  color: #d10404;
}
.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0!important;
}
.container .main .withdrawMoney .information{
  padding-bottom: 30px;
}
.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
.container .main .withdrawMoney span{
  padding: 10px 0;
}
.container .main .withdrawMoney .information .balance .number{
  color: #d10404;
}
.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
.withdraw-disabled-tip{
  margin:20px 30px;padding:20px;border-radius:12px;
  color:#ffd2d2;background:rgba(180,35,35,.35);
  border:1px solid #b94a48;font-size:25px;line-height:1.45;
}
.sub-btn.disabled{opacity:.45;filter:grayscale(1);cursor:not-allowed;}
</style>
